// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsbOutlinedSvg from "@fishx/icons-svg/es/asn/UsbOutlined";
import FishxIcon from '../components/FishxIcon';

var UsbOutlined = function UsbOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsbOutlinedSvg
  }));
};

UsbOutlined.displayName = 'UsbOutlined';
export default React.forwardRef(UsbOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UsbOutlined.js
// module id = 4331
// module chunks = 0